import { TrackingFnType } from '@hooks/useTracking'
import { ChatbotQuestionContext, TrackingEventType } from './types'
import config from '@config'

const {
  chatbot: { chatbotChatEndpoint, chatbotQuestionsEndpoint },
} = config

export const fetchQuestions = async (value: {
  text?: string
  context?: string
}) => {
  const url = `${chatbotQuestionsEndpoint}/questions`
  try {
    return await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify({
        publication: 'blick',
        ...(value.text && { text: value.text }),
        ...(value.context && { context: value.context }),
      }),
    })
  } catch (e) {
    return null
  }
}

export const fetchCachedQuestions = async (context: string) => {
  const url = `${chatbotQuestionsEndpoint}/questions?publication=blick&widgetId=questionWidget&context=${context}`
  try {
    return await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
  } catch (e) {
    return null
  }
}

export const fetchCachedAnswer = async (
  questionId: string,
  context = 'home'
) => {
  const url = `${chatbotQuestionsEndpoint}/answer?questionId=${questionId}&publication=blick&widgetId=questionWidget&context=${context}`
  try {
    return await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })
  } catch (e) {
    return null
  }
}

export const postPrompt = async (
  text: string,
  isSuggestedQuestion: boolean,
  context: ChatbotQuestionContext,
  conversationId?: string
) => {
  const url = `${chatbotChatEndpoint}/chat`
  try {
    const result = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: JSON.stringify({
        publication: 'blick',
        text,
        context,
        isSuggestedQuestion,
        ...(conversationId && { conversationId }),
      }),
    })

    return result
  } catch (e) {
    return null
  }
}

export const trackHandler: TrackingFnType<{
  event: TrackingEventType
  messageId?: string
  conversationId?: string | null
  isSuggestedQuestion?: boolean
  questionAnswered?: boolean | string | null
}> = ({
  extraData: {
    event,
    messageId,
    conversationId,
    isSuggestedQuestion,
    questionAnswered,
  },
}) => {
  const data = {
    event: event,
    conversation_id: conversationId,
    ...(typeof messageId !== 'undefined' && {
      chatbot_messageId: messageId,
    }),
    ...(typeof conversationId !== 'undefined' && {
      chatbot_conversationId: conversationId,
    }),
    ...(typeof isSuggestedQuestion !== 'undefined' && {
      chatbot_entrypoint: isSuggestedQuestion
        ? 'suggested question'
        : 'custom question',
    }),
    ...(typeof questionAnswered !== 'undefined' && {
      chatbot_question_answered: questionAnswered,
    }),
  }

  return data
}

export const removeLastDot = (text: string) => {
  if (text.endsWith('.')) {
    return text.slice(0, -1)
  }
  return text
}
